/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConfirmEmailRequestBody,
  ConfirmEmailResponse,
  GetPartnerResponse,
  HttpValidationProblemDetails,
  PostApiV1UserLoginHeaders,
  PostApiV1UserRefreshToken200,
  PostApiV1UserUserIdPartnerstackCustomerHeaders,
  PostPartnerEventRequestBody,
  PostPartnerRequestBody,
  PostPartnerResponse,
  PostUserGoogleLoginRequestBody,
  PostUserGoogleLoginResponse,
  PostUserLoginRequestBody,
  PostUserLoginResponse,
  ProblemDetails,
  PutUserPreferenceRequestBody,
  PutUserRegistrationQuestionAnswerRequestBody,
  RequestResetPasswordRequestBody,
  ResetPasswordRequestBody
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiV1UserLogin = (
    postUserLoginRequestBodyNull: PostUserLoginRequestBody | null,
    headers?: PostApiV1UserLoginHeaders,
 signal?: AbortSignal
) => {


      return apiClient<PostUserLoginResponse | null>(
      {url: `/api/v1/user/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', ...headers},
      data: postUserLoginRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1UserLoginMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserLogin>>, TError,{data: PostUserLoginRequestBody | null;headers?: PostApiV1UserLoginHeaders}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserLogin>>, TError,{data: PostUserLoginRequestBody | null;headers?: PostApiV1UserLoginHeaders}, TContext> => {

const mutationKey = ['postApiV1UserLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserLogin>>, {data: PostUserLoginRequestBody | null;headers?: PostApiV1UserLoginHeaders}> = (props) => {
          const {data,headers} = props ?? {};

          return  postApiV1UserLogin(data,headers,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserLogin>>>
    export type PostApiV1UserLoginMutationBody = PostUserLoginRequestBody | null
    export type PostApiV1UserLoginMutationError = ProblemDetails | null

    export const usePostApiV1UserLogin = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserLogin>>, TError,{data: PostUserLoginRequestBody | null;headers?: PostApiV1UserLoginHeaders}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserLogin>>,
        TError,
        {data: PostUserLoginRequestBody | null;headers?: PostApiV1UserLoginHeaders},
        TContext
      > => {
      return useMutation(getPostApiV1UserLoginMutationOptions(options), queryClient);
    }
    export const postApiV1UserGoogleLogin = (
    postUserGoogleLoginRequestBodyNull: PostUserGoogleLoginRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<PostUserGoogleLoginResponse | null>(
      {url: `/api/v1/user/google-login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserGoogleLoginRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1UserGoogleLoginMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserGoogleLogin>>, TError,{data: PostUserGoogleLoginRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserGoogleLogin>>, TError,{data: PostUserGoogleLoginRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1UserGoogleLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserGoogleLogin>>, {data: PostUserGoogleLoginRequestBody | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1UserGoogleLogin(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserGoogleLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserGoogleLogin>>>
    export type PostApiV1UserGoogleLoginMutationBody = PostUserGoogleLoginRequestBody | null
    export type PostApiV1UserGoogleLoginMutationError = ProblemDetails | null

    export const usePostApiV1UserGoogleLogin = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserGoogleLogin>>, TError,{data: PostUserGoogleLoginRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserGoogleLogin>>,
        TError,
        {data: PostUserGoogleLoginRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1UserGoogleLoginMutationOptions(options), queryClient);
    }
    export const postApiV1UserRefreshToken = (

 signal?: AbortSignal
) => {


      return apiClient<PostApiV1UserRefreshToken200>(
      {url: `/api/v1/user/refresh-token`, method: 'POST', signal
    },
      );
    }




export const getPostApiV1UserRefreshTokenMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserRefreshToken>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserRefreshToken>>, TError,void, TContext> => {

const mutationKey = ['postApiV1UserRefreshToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserRefreshToken>>, void> = () => {


          return  postApiV1UserRefreshToken()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserRefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserRefreshToken>>>

    export type PostApiV1UserRefreshTokenMutationError = ProblemDetails | null

    export const usePostApiV1UserRefreshToken = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserRefreshToken>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserRefreshToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostApiV1UserRefreshTokenMutationOptions(options), queryClient);
    }
    export const postApiV1UserLogout = (

 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/logout`, method: 'POST', signal
    },
      );
    }




export const getPostApiV1UserLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserLogout>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserLogout>>, TError,void, TContext> => {

const mutationKey = ['postApiV1UserLogout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserLogout>>, void> = () => {


          return  postApiV1UserLogout()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserLogout>>>

    export type PostApiV1UserLogoutMutationError = unknown

    export const usePostApiV1UserLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserLogout>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserLogout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostApiV1UserLogoutMutationOptions(options), queryClient);
    }
    export const postApiV1UserUserIdRequestEmailConfirmation = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/${userId}/request-email-confirmation`, method: 'POST', signal
    },
      );
    }




export const getPostApiV1UserUserIdRequestEmailConfirmationMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdRequestEmailConfirmation>>, TError,{userId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdRequestEmailConfirmation>>, TError,{userId: number}, TContext> => {

const mutationKey = ['postApiV1UserUserIdRequestEmailConfirmation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserUserIdRequestEmailConfirmation>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  postApiV1UserUserIdRequestEmailConfirmation(userId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserUserIdRequestEmailConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserUserIdRequestEmailConfirmation>>>

    export type PostApiV1UserUserIdRequestEmailConfirmationMutationError = ProblemDetails | null

    export const usePostApiV1UserUserIdRequestEmailConfirmation = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdRequestEmailConfirmation>>, TError,{userId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserUserIdRequestEmailConfirmation>>,
        TError,
        {userId: number},
        TContext
      > => {
      return useMutation(getPostApiV1UserUserIdRequestEmailConfirmationMutationOptions(options), queryClient);
    }
    export const postApiV1UserConfirmEmail = (
    confirmEmailRequestBodyNull: ConfirmEmailRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<ConfirmEmailResponse | null>(
      {url: `/api/v1/user/confirm-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmEmailRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1UserConfirmEmailMutationOptions = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserConfirmEmail>>, TError,{data: ConfirmEmailRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserConfirmEmail>>, TError,{data: ConfirmEmailRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1UserConfirmEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserConfirmEmail>>, {data: ConfirmEmailRequestBody | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1UserConfirmEmail(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserConfirmEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserConfirmEmail>>>
    export type PostApiV1UserConfirmEmailMutationBody = ConfirmEmailRequestBody | null
    export type PostApiV1UserConfirmEmailMutationError = HttpValidationProblemDetails | null | ProblemDetails

    export const usePostApiV1UserConfirmEmail = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserConfirmEmail>>, TError,{data: ConfirmEmailRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserConfirmEmail>>,
        TError,
        {data: ConfirmEmailRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1UserConfirmEmailMutationOptions(options), queryClient);
    }
    export const postApiV1UserRequestResetPassword = (
    requestResetPasswordRequestBodyNull: RequestResetPasswordRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/request-reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestResetPasswordRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1UserRequestResetPasswordMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserRequestResetPassword>>, TError,{data: RequestResetPasswordRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserRequestResetPassword>>, TError,{data: RequestResetPasswordRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1UserRequestResetPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserRequestResetPassword>>, {data: RequestResetPasswordRequestBody | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1UserRequestResetPassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserRequestResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserRequestResetPassword>>>
    export type PostApiV1UserRequestResetPasswordMutationBody = RequestResetPasswordRequestBody | null
    export type PostApiV1UserRequestResetPasswordMutationError = ProblemDetails | null

    export const usePostApiV1UserRequestResetPassword = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserRequestResetPassword>>, TError,{data: RequestResetPasswordRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserRequestResetPassword>>,
        TError,
        {data: RequestResetPasswordRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1UserRequestResetPasswordMutationOptions(options), queryClient);
    }
    export const getApiV1UserResetPasswordToken = (
    token: string | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/reset-password/${token}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1UserResetPasswordTokenQueryKey = (token: string | null,) => {
    return [
    `/api/v1/user/reset-password/${token}`
    ] as const;
    }


export const getGetApiV1UserResetPasswordTokenQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError = ProblemDetails | null>(token: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UserResetPasswordTokenQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>> = ({ signal }) => getApiV1UserResetPasswordToken(token, signal);





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UserResetPasswordTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>>
export type GetApiV1UserResetPasswordTokenQueryError = ProblemDetails | null


export function useGetApiV1UserResetPasswordToken<TData = Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError = ProblemDetails | null>(
 token: string | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UserResetPasswordToken<TData = Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError = ProblemDetails | null>(
 token: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UserResetPasswordToken<TData = Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError = ProblemDetails | null>(
 token: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UserResetPasswordToken<TData = Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError = ProblemDetails | null>(
 token: string | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserResetPasswordToken>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UserResetPasswordTokenQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiV1UserResetPasswordToken = (
    token: string | null,
    resetPasswordRequestBodyNull: ResetPasswordRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/reset-password/${token}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1UserResetPasswordTokenMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UserResetPasswordToken>>, TError,{token: string | null;data: ResetPasswordRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1UserResetPasswordToken>>, TError,{token: string | null;data: ResetPasswordRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1UserResetPasswordToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1UserResetPasswordToken>>, {token: string | null;data: ResetPasswordRequestBody | null}> = (props) => {
          const {token,data} = props ?? {};

          return  putApiV1UserResetPasswordToken(token,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1UserResetPasswordTokenMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1UserResetPasswordToken>>>
    export type PutApiV1UserResetPasswordTokenMutationBody = ResetPasswordRequestBody | null
    export type PutApiV1UserResetPasswordTokenMutationError = ProblemDetails | null

    export const usePutApiV1UserResetPasswordToken = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UserResetPasswordToken>>, TError,{token: string | null;data: ResetPasswordRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1UserResetPasswordToken>>,
        TError,
        {token: string | null;data: ResetPasswordRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1UserResetPasswordTokenMutationOptions(options), queryClient);
    }
    export const postApiV1UserUserIdRequestAccountDeletion = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/${userId}/request-account-deletion`, method: 'POST', signal
    },
      );
    }




export const getPostApiV1UserUserIdRequestAccountDeletionMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdRequestAccountDeletion>>, TError,{userId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdRequestAccountDeletion>>, TError,{userId: number}, TContext> => {

const mutationKey = ['postApiV1UserUserIdRequestAccountDeletion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserUserIdRequestAccountDeletion>>, {userId: number}> = (props) => {
          const {userId} = props ?? {};

          return  postApiV1UserUserIdRequestAccountDeletion(userId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserUserIdRequestAccountDeletionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserUserIdRequestAccountDeletion>>>

    export type PostApiV1UserUserIdRequestAccountDeletionMutationError = ProblemDetails | null

    export const usePostApiV1UserUserIdRequestAccountDeletion = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdRequestAccountDeletion>>, TError,{userId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserUserIdRequestAccountDeletion>>,
        TError,
        {userId: number},
        TContext
      > => {
      return useMutation(getPostApiV1UserUserIdRequestAccountDeletionMutationOptions(options), queryClient);
    }
    export const putApiV1UserUserIdPreference = (
    userId: number,
    putUserPreferenceRequestBodyNull: PutUserPreferenceRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/${userId}/preference`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserPreferenceRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1UserUserIdPreferenceMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UserUserIdPreference>>, TError,{userId: number;data: PutUserPreferenceRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1UserUserIdPreference>>, TError,{userId: number;data: PutUserPreferenceRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1UserUserIdPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1UserUserIdPreference>>, {userId: number;data: PutUserPreferenceRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  putApiV1UserUserIdPreference(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1UserUserIdPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1UserUserIdPreference>>>
    export type PutApiV1UserUserIdPreferenceMutationBody = PutUserPreferenceRequestBody | null
    export type PutApiV1UserUserIdPreferenceMutationError = ProblemDetails | null

    export const usePutApiV1UserUserIdPreference = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UserUserIdPreference>>, TError,{userId: number;data: PutUserPreferenceRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1UserUserIdPreference>>,
        TError,
        {userId: number;data: PutUserPreferenceRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1UserUserIdPreferenceMutationOptions(options), queryClient);
    }
    export const putApiV1UserUserIdRegistrationQuestionQuestionId = (
    userId: number,
    questionId: number,
    putUserRegistrationQuestionAnswerRequestBodyNull: PutUserRegistrationQuestionAnswerRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/${userId}/registration-question/${questionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserRegistrationQuestionAnswerRequestBodyNull, signal
    },
      );
    }




export const getPutApiV1UserUserIdRegistrationQuestionQuestionIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UserUserIdRegistrationQuestionQuestionId>>, TError,{userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1UserUserIdRegistrationQuestionQuestionId>>, TError,{userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1UserUserIdRegistrationQuestionQuestionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1UserUserIdRegistrationQuestionQuestionId>>, {userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null}> = (props) => {
          const {userId,questionId,data} = props ?? {};

          return  putApiV1UserUserIdRegistrationQuestionQuestionId(userId,questionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1UserUserIdRegistrationQuestionQuestionIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1UserUserIdRegistrationQuestionQuestionId>>>
    export type PutApiV1UserUserIdRegistrationQuestionQuestionIdMutationBody = PutUserRegistrationQuestionAnswerRequestBody | null
    export type PutApiV1UserUserIdRegistrationQuestionQuestionIdMutationError = ProblemDetails | null

    export const usePutApiV1UserUserIdRegistrationQuestionQuestionId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1UserUserIdRegistrationQuestionQuestionId>>, TError,{userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1UserUserIdRegistrationQuestionQuestionId>>,
        TError,
        {userId: number;questionId: number;data: PutUserRegistrationQuestionAnswerRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1UserUserIdRegistrationQuestionQuestionIdMutationOptions(options), queryClient);
    }
    export const postApiV1UserUserIdPartner = (
    userId: number,
    postPartnerRequestBodyNull: PostPartnerRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<PostPartnerResponse | null>(
      {url: `/api/v1/user/${userId}/partner`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPartnerRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1UserUserIdPartnerMutationOptions = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdPartner>>, TError,{userId: number;data: PostPartnerRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdPartner>>, TError,{userId: number;data: PostPartnerRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1UserUserIdPartner'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserUserIdPartner>>, {userId: number;data: PostPartnerRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  postApiV1UserUserIdPartner(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserUserIdPartnerMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserUserIdPartner>>>
    export type PostApiV1UserUserIdPartnerMutationBody = PostPartnerRequestBody | null
    export type PostApiV1UserUserIdPartnerMutationError = HttpValidationProblemDetails | null | ProblemDetails

    export const usePostApiV1UserUserIdPartner = <TError = HttpValidationProblemDetails | null | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdPartner>>, TError,{userId: number;data: PostPartnerRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserUserIdPartner>>,
        TError,
        {userId: number;data: PostPartnerRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1UserUserIdPartnerMutationOptions(options), queryClient);
    }
    export const getApiV1UserUserIdPartner = (
    userId: number,
 signal?: AbortSignal
) => {


      return apiClient<GetPartnerResponse | null>(
      {url: `/api/v1/user/${userId}/partner`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1UserUserIdPartnerQueryKey = (userId: number,) => {
    return [
    `/api/v1/user/${userId}/partner`
    ] as const;
    }


export const getGetApiV1UserUserIdPartnerQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError = ProblemDetails | null>(userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1UserUserIdPartnerQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>> = ({ signal }) => getApiV1UserUserIdPartner(userId, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1UserUserIdPartnerQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>>
export type GetApiV1UserUserIdPartnerQueryError = ProblemDetails | null


export function useGetApiV1UserUserIdPartner<TData = Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError = ProblemDetails | null>(
 userId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UserUserIdPartner<TData = Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>,
          TError,
          Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1UserUserIdPartner<TData = Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1UserUserIdPartner<TData = Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError = ProblemDetails | null>(
 userId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1UserUserIdPartner>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1UserUserIdPartnerQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiV1UserUserIdPartnerEvents = (
    userId: number,
    postPartnerEventRequestBodyNull: PostPartnerEventRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/${userId}/partner/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPartnerEventRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1UserUserIdPartnerEventsMutationOptions = <TError = HttpValidationProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerEvents>>, TError,{userId: number;data: PostPartnerEventRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerEvents>>, TError,{userId: number;data: PostPartnerEventRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1UserUserIdPartnerEvents'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerEvents>>, {userId: number;data: PostPartnerEventRequestBody | null}> = (props) => {
          const {userId,data} = props ?? {};

          return  postApiV1UserUserIdPartnerEvents(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserUserIdPartnerEventsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerEvents>>>
    export type PostApiV1UserUserIdPartnerEventsMutationBody = PostPartnerEventRequestBody | null
    export type PostApiV1UserUserIdPartnerEventsMutationError = HttpValidationProblemDetails | null

    export const usePostApiV1UserUserIdPartnerEvents = <TError = HttpValidationProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerEvents>>, TError,{userId: number;data: PostPartnerEventRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserUserIdPartnerEvents>>,
        TError,
        {userId: number;data: PostPartnerEventRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1UserUserIdPartnerEventsMutationOptions(options), queryClient);
    }
    export const postApiV1UserUserIdPartnerstackCustomer = (
    userId: number,
    headers?: PostApiV1UserUserIdPartnerstackCustomerHeaders,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/user/${userId}/partnerstack-customer`, method: 'POST',
      headers, signal
    },
      );
    }




export const getPostApiV1UserUserIdPartnerstackCustomerMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerstackCustomer>>, TError,{userId: number;headers?: PostApiV1UserUserIdPartnerstackCustomerHeaders}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerstackCustomer>>, TError,{userId: number;headers?: PostApiV1UserUserIdPartnerstackCustomerHeaders}, TContext> => {

const mutationKey = ['postApiV1UserUserIdPartnerstackCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerstackCustomer>>, {userId: number;headers?: PostApiV1UserUserIdPartnerstackCustomerHeaders}> = (props) => {
          const {userId,headers} = props ?? {};

          return  postApiV1UserUserIdPartnerstackCustomer(userId,headers,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1UserUserIdPartnerstackCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerstackCustomer>>>

    export type PostApiV1UserUserIdPartnerstackCustomerMutationError = ProblemDetails | null

    export const usePostApiV1UserUserIdPartnerstackCustomer = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1UserUserIdPartnerstackCustomer>>, TError,{userId: number;headers?: PostApiV1UserUserIdPartnerstackCustomerHeaders}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1UserUserIdPartnerstackCustomer>>,
        TError,
        {userId: number;headers?: PostApiV1UserUserIdPartnerstackCustomerHeaders},
        TContext
      > => {
      return useMutation(getPostApiV1UserUserIdPartnerstackCustomerMutationOptions(options), queryClient);
    }
